// extracted by mini-css-extract-plugin
export var numberInputContainer = "_5g-0";
export var startPickingButton = "_5g-1";